import script from "./Profile.vue?vue&type=script&setup=true&lang=ts"
export * from "./Profile.vue?vue&type=script&setup=true&lang=ts"

import "./Profile.vue?vue&type=style&index=0&id=37be393e&lang=css"

const __exports__ = script;

export default __exports__